"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _fieldBase = _interopRequireDefault(require("../field-base"));
var _checkboxBase = _interopRequireDefault(require("./checkbox-base"));
require("./styles/field.css");
var _excluded = ["className", "checkboxId", "checked", "label", "secondaryLabel", "useInactiveStyle", "onUpdate"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * A checkbox and label styled within a FieldBase that pairs well visually with other
 * inputs in this library like Field and Select. The secondary label is optional.
 */
var CheckboxField = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
    checkboxId = _ref.checkboxId,
    _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    label = _ref.label,
    secondaryLabel = _ref.secondaryLabel,
    useInactiveStyle = _ref.useInactiveStyle,
    _ref$onUpdate = _ref.onUpdate,
    onUpdate = _ref$onUpdate === void 0 ? function () {} : _ref$onUpdate,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(checked),
    _useState2 = _slicedToArray(_useState, 2),
    isChecked = _useState2[0],
    setIsChecked = _useState2[1];
  var handleChange = function handleChange() {
    setIsChecked(!isChecked);
    onUpdate();
  };
  return /*#__PURE__*/_react["default"].createElement(_fieldBase["default"], _extends({
    childWrapperClassName: className,
    enableValidationMessage: false,
    floatLabelActive: Boolean(secondaryLabel),
    floatLabelAriaHidden: true,
    floatLabelText: secondaryLabel,
    useFocusStyle: isChecked,
    useInactiveStyle: useInactiveStyle
  }, props), /*#__PURE__*/_react["default"].createElement("label", {
    className: "checkboxField__label cursor-pointer flex flex-grow justify-between",
    htmlFor: checkboxId
  }, label, secondaryLabel ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "hiddenVisually"
  }, ", ".concat(secondaryLabel)) : null, /*#__PURE__*/_react["default"].createElement(_checkboxBase["default"], {
    checkboxId: checkboxId,
    checked: isChecked,
    className: "checkboxField__checkbox",
    onChange: handleChange,
    ref: ref
  })));
});
CheckboxField.displayName = 'CheckboxField';
CheckboxField.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * styling is passed to `<FieldBase>` childWrapperClassName
   */
  className: _propTypes["default"].string,
  checkboxId: _propTypes["default"].string,
  /**
   * Optional secondary label that will appear in the 'active' position in the field
   * styling that wraps the checkbox
   */
  secondaryLabel: _propTypes["default"].string,
  /**
   * Primary label for the checkbox
   */
  label: _propTypes["default"].string.isRequired,
  /**
   * Styling that will make the field appear greyed out and recessed
   */
  useInactiveStyle: _propTypes["default"].bool,
  /**
   * Function that will get called on checkbox click
   */
  onUpdate: _propTypes["default"].func
} : {};
var _default = exports["default"] = CheckboxField;